import { useState, useCallback } from 'react';
import { modals } from '@mantine/modals';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { ChatBotData, getGetApiChatBotDataListQueryKey, useDeleteApiChatBotDataDelete } from '@/API';

export const useDeleteChatBotData = () => {
    const queryClient = useQueryClient();
    const deleteChatBotData_Mutation = useDeleteApiChatBotDataDelete();
    const [loading, setLoading] = useState(false);

    const confirmAndDelete = useCallback((data: ChatBotData, onDelete?: () => void) => {
        modals.openConfirmModal({
            title: '刪除聊天機器人',
            radius: "lg",
            children: (
                <Text size="sm">
                    是否要刪除 {data.name ?? ""}?
                </Text>
            ),
            labels: { confirm: '刪除', cancel: '取消' },
            confirmProps: { color: 'red' },
            onConfirm: async () => {
                setLoading(true);
                try {
                    if (data.id) {
                        await deleteChatBotData_Mutation.mutateAsync({ params: { workspaceId: data.workspaceId, id: data.id } })
                        notifications.show({ message: "刪除成功" })
                        queryClient.invalidateQueries({ queryKey: getGetApiChatBotDataListQueryKey() })
                        onDelete?.()
                    }
                } catch (ex) {
                    notifications.show({ message: "刪除失敗", color: "red" })
                }
                setLoading(false);
            },
        });
    }, [deleteChatBotData_Mutation, queryClient]);

    return {
        confirmAndDelete: confirmAndDelete,
        loading: loading,
    };
};